<template>
  <div class="header-wrap">
    <!-- header-top -->
    <div class="header-top" style="overflow:inherit;">
      <div class="wp">
        <div class="l">
          <div class="ban-news">
            <div
              class="container"
              :style="'transform: translate3d(0px, ' + top + 'px, 0px);'"
            >
              <div class="item" v-for="(item, idx) in news" :key="idx">
                <a :href="'#/notificationinfo/' + item.announcementId">{{
                  item.title
                }}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="r">
          <div class="m-topnav">
            <div style="position: relative; display: flex; align-items: center;" v-if="user.userId" class="item">
              <span v-if="$length" style="position: absolute; left: 10px; top: 6px; width: 12px; height: 12px; border-radius: 50%; background: #f00; color: #fff; font-size: 10px; line-height: 12px; text-align: center;">{{$length}}</span>
              <i class="el-icon-chat-dot-round" style=" font-size:16px; padding-right:16px; " @click="msgg"></i>
              <p>
                {{ user.companyName }}&nbsp;&nbsp;|&nbsp;&nbsp;<a
                  href="#/enterprise/home"
                  >我的运贸</a
                >
              </p>
            </div>
            <div v-if="user.userId" class="item">
              <p>
                <!-- <a href="#/enterprise/home" v-if="user.enterStatus == 1"
                  >卖家_物流接单中心</a
                >&nbsp;| -->
                <span >
                  <a href="#/settlement"
                  v-if="user.enterStatus == 3||user.enterStatus==2"
                     >入驻</a
                   >
                  <!-- <a href="#/stands" v-if="user.enterStatus == 1"
                     >入驻</a
                   > -->
                   <a href="#/settlement" v-if="user.enterStatus==0">审核中</a>
                </span>
              </p>
            </div>
            <div v-if="user.userId" class="item">
              <p><a @click="loginout">退出登录</a></p>
            </div>
            <div v-if="!user.userId" class="item">
              <p style="font-weight: 550;"><a href="#/login">登录</a>/<a href="#/register">注册</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- header-top end -->
    <!-- header -->
    <div class="header">
      <div class="wp">
          <div class="logo" style="margin-top: 14px; width: 160px;">
            <a href="#/index">
              <img src="../assets/images/logo.png" style="" alt="" />
            </a>
          </div>
          <div class="hd-center">
            <div class="top">
              <div v-if="$root.juzhan" class="g-select-area" id="townArea"  @click="showPop = !showPop;showResult=false">
                <!-- {{ currentStand.standName }} -->
                {{$root.juzhan.standName}}
              </div>
              <div class="hd-search autocomplete-box">
                <div class="inp">
                  <input id="townKey" v-model="townKey" @focus="showPop=false" @keyup="keypressSearch" type="text" placeholder="请输入站名" />
                </div>
                <div class="submit">
                  <input type="submit" value="搜索" />
                </div>
                <div class="search-result" v-if="showResult && searchlist.length > 0">
                <a
                  v-for="(item, idx) in searchlist"
                  :key="idx"
                  @click="chooseStandForSearch(item)"
                  >{{ item.standName }}</a
                >
              </div>
              </div>
            </div>
            <div class="hd-message">
              <a class="more" @click="showMore = true">查看更多</a>
              <div class="con">
                {{ currentStand.address }}，电话：{{ currentStand.phone }}；
              </div>
            </div>
          </div>
          <div class="hd-phone">400-089-6668</div>
      </div>
    </div>
    <!-- header end -->
    <!-- nav -->
    <div class="nav">
      <div class="wp">
        <ul class="ul-nav page-nav">
          <li
            v-for="(p, pdx) in menus"
            :key="pdx"
            :class="{ 'on': currentPath == p.path }"
            @click="toPage(p)"
          >
            <a v-if="$root.userComponey!=2" class="v1">{{ p.title }}</a>
            <a v-if="$root.userComponey==2&&p.id!=3&&p.id!=7&&p.id!=8&&p.id!=9 " class="v1">{{ p.title }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="pop11"
      style="
        position: fixed;
        top: 0px;
        left: 0px;
        background-color: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 100%;
        z-index: 10;
        display: block;
      "
      v-if="showMore"
    >
      <div
        style="
          background: #FFFFFF;
          border-radius: 10px;
          position: fixed;
          top: 47%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 659px;
          box-sizing: border-box;
          padding: 0 40px 40px 40px;
        "
      >
        <div
          style="
            width: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 30px 0;
          "
          class="pop11name"
        >
          <span
            style="
              font-size: 13px;
              font-family: 'PingFangSC-Regular, PingFang SC';
              font-weight: 400;
              color: #282828;
            "
            >局站详情</span
          >
          <img
            @click="showMore = false"
            src="../assets/images/close.png"
            style="
              font-size: 13px;
              font-family: 'PingFangSC-Regular, PingFang SC';
              font-weight: 400;
              color: #282828;
              cursor: pointer;
            "
          />
        </div>
        <p style="color: #000; text-align: justify; line-height: 22px; font-size: 13px">
          站名：<span id="hstandName">{{ currentStand.standName }}</span>
        </p>
        <p style="color: #000; text-align: justify; line-height: 22px; font-size: 13px">
          电话：<span id="hphone">{{ currentStand.phone }}</span>
        </p>
        <p style="color: #000; text-align: justify; line-height: 22px; font-size: 13px">
          地址：<span id="haddress">{{ currentStand.address }} &nbsp;</span>
        </p>
        <p style="color: #000; text-align: justify; line-height: 22px; font-size: 13px">
          办理限制：<span id="hdealWithLimited">{{
            currentStand.dealWithLimited
          }}</span>
        </p>
      </div>
    </div>

    <div class="area-container" v-if="showPop">
      <div class="current-area" v-if="provinceStr">
        <span @click.stop="areaStep = 1" v-if="provinceStr">{{
          provinceStr
        }}</span>
        <span
          v-if="cityStr && (areaStep == 2 || areaStep == 3)"
          @click.stop="areaStep = 2"
          >{{ cityStr }}</span
        >
        <span
          v-if="currentStand.standName && areaStep == 3"
          @click.stop="areaStep = 3"
          >{{ currentStand.standName }}</span
        >
      </div>
      <div class="container-box">
        <div class="province" v-if="areaStep == 1">
          <span
            v-for="(item, idx) in province"
            :key="idx"
            @click.stop="changeProvince(item)"
            >{{ item.name }}</span
          >
        </div>
        <div class="city" v-if="areaStep == 2">
          <span
            v-for="(item, idx) in city"
            :key="idx"
            @click.stop="changeCity(item)"
            >{{ item.name }}</span
          >
        </div>
        <div class="stand" v-if="areaStep == 3">
          <span
            v-for="(item, idx) in stands"
            :key="idx"
            @click.stop="changeStand(item)"
            >{{ item.standName }}</span
          >
        </div>
      </div>
    </div>

    <div class="return" id="myBtn" @click="toTop">
      <img src="../assets/images/dingbu.png" alt="" />
    </div>

    <div class="flotage "  >
      <div class="flotage_div">
        <div class="flotage_box" style="background: rgba(248, 134, 42, 1); color: #fff;">
          <a @click="toOrder">
            <!-- <img
              src="../assets/images/weizifu.png"
              alt=""
              class="flotage_img1"
            /> -->
            <img
              src="../assets/images/weizifu1.png"
              alt=""
            />
            <p style="color: #FFF;">未支付订单</p>
          </a>
        </div>
        <div @click="toMsg(981901001332098048)" class="flotage_box ">
          <a target="blank" href="#/message/981901001332098048">
            <img src="../assets/images/kefu.png" alt="" class="flotage_img1" />
            <img src="../assets/images/kefu1.png" alt="" class="flotage_img2" />
            <p>客服</p>
          </a>
            <!-- <img src="../assets/images/kefu.png" alt="" class="flotage_img1" />
            <img src="../assets/images/kefu1.png" alt="" class="flotage_img2" />
            <p>客服</p> -->
        </div>
        <div class="flotage_box flotage_kefu">
          <a href="">
            <img
              src="../assets/images/dianhua.png"
              alt=""
              class="flotage_img1"
            />
            <img
              src="../assets/images/dianhua1.png"
              alt=""
              class="flotage_img2"
            />
            <p>电话</p>
          </a>

          <div class="flotage_phone">
            <p>客服电话</p>
            <p>400-089-6668</p>
          </div>
        </div>
        <!-- <div class="flotage_box">
          <a href="#/feedback">
            <img
              src="../assets/images/fankui.png"
              alt=""
              class="flotage_img1"
            />
            <img
              src="../assets/images/fankui1.png"
              alt=""
              class="flotage_img2"
            />
            <p>反馈</p>
          </a>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { searchStand, homTopView, isOnlineBankingBinding } from "@/services/index";
import { getUserInfo, pushMessageList ,getImUserSig} from "@/services/usercenter";
import { announcementList } from "@/services/index";
import {getEnterpriseInfo} from '@/services/qiye'
import areadata from "@/utils/area";
export default {
  data() {
    return {
      length:'',
      bol:false,
      showAdv:false,
      top: 0,
      showMore: false,
      currentPath: "",
      user: {},
      enterStatus: {
        0: "审核中",
        1: "审核通过",
        2: "审核失败",
        3: "未入驻",
      },
      province: [],
      city: [],
      stands: [],
      areaStep: 1,
      provinceStr: "",
      cityStr: "",
      showPop: false,
      news: [],
      menus: [
        { title: "首页", path: "/index",id:1 },
        { title: "今日销售价", path: "/todaysaleprice",id:2 },
        { title: "铁路发货", path: "/deliver",id:3 },
        { title: "公路发货", path: "/freighttransport",id:4 },
        { title: "视频销售", path: "/salevideos",id:5 },
        { title: "今日收购价", path: "/todayacquisitionprice",id:6 },
        { title: "企业门店", path: "/enterpriseStore",id:7},
        { title: "国内需求", path: "/domesticEmand",id:8 },
        { title: "国际需求", path: "/demand/international",id:9 },
        { title: "保险购买", path: "/insurance" ,id:10},
        { title: "公告通知", path: "/notification",id:11 },
      ],
      currentStand: {},
      curAdvIdx: 0,
      townKey:'',
      showResult:false,
      searchList:[],
      areas:{},
      params:{
        userId:''
      },
      usersig:'',
      userid:'',
      touserid:'',
    };
  },
  watch:{
      '$route':function(newUrl,oldUrl){
          if(newUrl!=oldUrl){
             let href = location.href;
            let str = href.substring(href.indexOf("#") + 1);
            this.menus.forEach((f) => {
              // console.log(str)
              if (f.path == str||str.indexOf(f.path)>-1||f.path.indexOf(str)>-1) {
                this.currentPath = f.path;
              }
            });
          }
      }
  },
  mounted() {
    let that = this;


    this.areas=areadata;
    document.body.addEventListener('click',function(e){
      if(e.target.id!='townKey'&&e.target.id!='townArea'){
        that.showResult=false;
        that.showPop=false;
      }
    })
    this.province = areadata.provinces;
    let u=localStorage.getItem('USERINFO');
    // if(!u){ return}
    if(u){
       getUserInfo().then(res=>{
        // console.log(res.result)
        that.user=res.result;
        that.userid = res.result.userId;

        getImUserSig().then(res=>{
          // console.log(res.result)
          that.userSig = res.result;
          that.logData(that.userid,that.userSig);
        })

        // console.log(that.user,'ppp')

        that.$emit("refreshEnterStatus", res.result.userId);
        this.$root.userNum=res.result.enterStatus;
        this.$root.userId=res.result.userId;

        if(this.$root.userNum==1){
          getEnterpriseInfo().then(res=>{

              this.$root.userComponey=res.result.identityId;
              // console.log(12,res.result.userIdentityInfoDtoNow.payCostStatus)
              if(res.result.userIdentityInfoDtoNow.payCostStatus!=1){
                this.$root.userNum=4
              }
              // console.log('a',this.$root.userComponey,this.$root.userNum)
          })
        }else{
          // console.log('b',this.$root.userComponey,this.$root.userNum)
        }
      })


      homTopView().then((res) => {
        // console.log(res.result.defStandDto,'头')
        this.$store.state.standId=res.result.defStandDto.standId;
        this.$store.state.bureauId=res.result.defStandDto.bureauId;
        // console.log(this.$store.state.standId,this.$store.state.bureauId,'全局' )

        // this.$root.juzhan=res.result.defStandDto;
        that.currentStand = res.result.defStandDto;
        that.provinceStr = res.result.defStandDto.province;
        that.cityStr = res.result.defStandDto.town;
        that.areaStep = 3;
        let _city = areadata.citys.filter((f) => {
          return f.name == that.currentStand.town;
        });
        let _citys = areadata.citys.filter((f) => {
          return f.parent_id == _city[0].parent_id;
        });
        that.city = _citys;
        searchStand({ town: res.result.defStandDto.town }).then((res) => {
          that.stands = res.result;
          that.areaStep = 3;
        });
      });
    }

    let href = location.href;
    let str = href.substring(href.indexOf("#") + 1);
    this.menus.forEach((f) => {
      // console.log(str)
      if (f.path == str||str.indexOf(f.path)>-1||f.path.indexOf(str)>-1) {
        this.currentPath = f.path;
      }
    });

    announcementList().then((res) => {
      that.news = res.result.list;
      if (that.news.length > 1) {
        setInterval(function () {
          if (that.curAdvIdx == that.news.length - 1) {
            that.top = 0;
            that.curAdvIdx = 0;
          } else {
            that.top -= 25;
            that.curAdvIdx++;
          }
        }, 2000);
      }
    });

    isOnlineBankingBinding().then(res=>{
      // console.log(res,'绑卡')
      this.$store.state.bangka = res.result;
      // console.log(this.$store.state.bangka)
    })

  },
  created() {
    window.onscroll = function () {
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        document.getElementById("myBtn").style.display = "block";
      } else {
        document.getElementById("myBtn").style.display = "none";
      }
    };
  },
  computed:{


  },
  methods: {
    toMsg(path){

    },
    chooseStandForSearch(item){
      this.showResult=false;
      let province=this.areas.provinces.filter(f=>{
        return f.name==item.province;
      })

      let city=this.areas.citys.filter(f=>{
        return f.parent_id==province[0].id;
      })
      let _city=this.areas.citys.filter(f=>{
        return f.name==item.town;
      })
      this.provinceStr=item.province;
      this.cityStr=item.town;

      this.city=city;
      this.townKey='';
      this.currentStand=item;
      this.$root.juzhan=item;
      // console.log(111)
      // console.log(item)
      // console.log(111)
      let that=this;
      this.$emit("callback", item.standId);
      searchStand({ town: item.town }).then((res) => {
        that.stands = res.result;
        that.areaStep = 3;
        // console.log('aa', res.result);
      });
    },
     keypressSearch(e){
      let that=this;
      if(this.townKey){
        searchStand({ searchValue:that.townKey}).then(res=>{
          if(res.code==200){
            // console.log(222)
            that.searchlist=res.result;
            that.showResult=true;
          }
        })
      }else{
        that.searchlist=[];
        that.showResult=false;
      }
    },
    toOrder(){
      let u=localStorage.getItem('USERINFO');
      if(u){
        this.$router.push('/user/logisticorder')
      }else{
        this.$router.push('/login')
      }
    },

    msgg(){
      // console.log(this.$touserid);
      let routeData = this.$router.resolve({
        path: "message/"+this.$touserid,
      });
      window.open(routeData.href, '_blank');
    },
    toTop() {
      // debugger
      // document.querySelector("body").scrollIntoView({
      //   //滚动到指定节点
      //   block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
      //   behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
      // });
      window.scrollTo(0,0);
    },
    changeProvince(item) {
      this.city = [];
      this.city = areadata.citys.filter((f) => {
        return f.parent_id == item.id;
      });
      this.provinceStr = item.name;
      this.areaStep = 2;
    },
    changeCity(item) {
      let that = this;
      this.cityStr = item.name;
      searchStand({ town: item.name }).then((res) => {
        that.stands = res.result;
        that.areaStep = 3;
      });
    },
    changeStand(item) {
      this.currentStand = item;
      this.showPop = false;
      this.$root.juzhan=item;
      this.currentStand.name = item.name;
      // this.
      homTopView({
        cityName: this.cityStr,
        standId: this.currentStand.standId,
      }).then((res) => {
        // console.log(res.result, 'abc')
      });
      this.$emit("callback", item.standId);
    },
    loginout() {
      localStorage.removeItem("USERINFO");
      localStorage.removeItem("CUROFFER");
      this.$router.push("/login");
    },
    toPage(item) {
      this.currentPath = item.path;
      this.$router.push(item.path);
    },

    logData(userID,userSig){
        const self = this
        let promise = this.tim.login({userID: userID, userSig: userSig});


    },
  },
};
</script>

<style scoped>
.page-nav li {
  cursor: pointer;
}

.g-select-area {
  /* border:1px solid red; */
  position: relative;
  overflow: initial;
  cursor: pointer;
  text-align: center;
  user-select: none;
}

.area-container {
  position: absolute;
  left: 23%;
  top: 13%;
  z-index: 1111111111;
  height: 400px;
  border-radius: 3px;
  box-sizing: border-box;
  border: 1px solid #cecbce;
  width: 550px;
  padding: 15px;
  background: #fff;
  box-shadow: 0 0 5px #ddd;
}
.top {
  overflow: initial !important;
}
.header {
  /* overflow:visible !important; */
}
.area-container > .container-box > div > span {
  display: inline-block;
  float: left;
  /* border:1px solid red; */
  padding: 0px 10px;
  min-width: 120px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  line-height: 30px;
}
.current-area {
  margin-bottom: 50px;
}
.area-container > div {
  text-align: left;
  clear: both;
}
.area-container > .container-box > div > span:hover {
  color: #fff;
  background: #B79567;
  /* border:1px solid #ddd; */
}
.current-area span {
  /* border:1px solid red; */
  padding: 0px 10px;
  min-width: 120px;
  display: inline-block;
  text-align: center;
  user-select: none;
  cursor: pointer;

  float: left;
  clear: none;
  height: 23px;
  padding: 1px 1px 0;
  border: 1px solid #ddd;
  border-bottom: 0;
  margin-right: 3px;
  background-color: #fff;
  line-height: 22px;
  position: relative;
  text-decoration: none;
  padding: 0px 20px;
}
.current-area span:after {
  content: "";
  width: 12px;
  height: 6px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjFGMTkzNDVGRUQwMTExRUFBQkMwRURFNzMzMTlFNEJEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjFGMTkzNDYwRUQwMTExRUFBQkMwRURFNzMzMTlFNEJEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MUYxOTM0NURFRDAxMTFFQUFCQzBFREU3MzMxOUU0QkQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MUYxOTM0NUVFRDAxMTFFQUFCQzBFREU3MzMxOUU0QkQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz63FaGpAAAAT0lEQVR42mLZtGnTdAYGhgwG4sAMJiCRBWIQoxiklvH///8MmzdvZgRypuGxCazY19f3P1gDCODRBFcM4sA14NCEohhDA5omBnTFIAAQYABjqiiwzIKZiAAAAABJRU5ErkJggg==) center center no-repeat;
  background-size: contain;
  display: block;
  position: absolute;
  right: 4px;
  top: 50%;
  margin-top: -3px;
  z-index: 2;
}

.container {
  overflow: hidden;
  transition: 0.3s all linear;
}

.container .item {
  height: 25px;
}
.return {
  position: fixed;
  right: 20px;
  bottom: 200px;
  z-index: 15;
  width: 59px;
  height: 59px;
  background: #FFFFFF;
  border: 1px solid #E6E6E6;
  display: none;
}
.app div {
    position: absolute;
    top: 35px;
    background: #fff;
    padding: 10px;
    z-index: 1000;
    width: 120px;
    box-sizing: border-box;
    display: none;
}
.app:hover div {
    display: block;
}

.autocomplete-box{
  position: relative;
  width:100%;
}
.search-result{
  position: absolute;
  border:1px solid #ddd;
  width:100%;height:200px;
  background:#fff;
  z-index:999999999;
  border-top:none;
  left:0px;
  overflow-y: auto;
}
.search-result a{
  display:inline-block;
  width:100%;
  text-align: left;
  height:30px;
  padding:0px 10px;
  font-size:14px;
  /* background:#eee;
  border:1px solid red;
  color:#000; */
  line-height:30px;
}
.search-result a:hover{
  background:#ccc;
}

.top{
  display: flex;
}
.hd-message,.hd-search{
  overflow:inherit !important;
}
.header{
  z-index: 9;
  position: relative;
  overflow: initial !important;
  height:160px;
}
.nav{
  position: relative;
}
.header-wrap{
  display:block;
  width:100%;
}



</style>



// WEBPACK FOOTER //
// src/components/header.vue